import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import Layout from "./layout/Layout";
import { checkAuthenticated } from "./redux/slices/loginSlice";


function App() {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  dispatch(checkAuthenticated({}));


  // const { isLoading } = useSelector((state: any) => state.chmActivity);
  

  return (
    <div className="App">
    
      <Layout />
    
    </div>
  );
}

export default App;
